// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__34zxN","footer":"ChangeClinic_footer__3Ph8e"};